export const FETCH_ELEGIBLE_PMS_TYPE = 'PAYMENTS/ELEGIBLE/FETCH_ELEGIBLE_PMS_TYPE'
export const SET_FETCHING_ELEGIBLE_PMS_TYPE = 'PAYMENTS/ELEGIBLE/SET_FETCHING_ELEGIBLE_PMS_TYPE'
export const SET_FETCH_ELEGIBLE_ERROR_PMS_TYPE =
  'PAYMENTS/ELEGIBLE/SET_FETCH_ELEGIBLE_ERROR_PMS_TYPE'
export const SET_ELEGIBLE_PMS_TYPE = 'PAYMENTS/ELEGIBLE/SET_ELEGIBLE_PMS_TYPE'
